import type { StateCreator } from 'zustand'

import type { GeneratedKeySecrets, ProjectResourceGroup } from '../project-keys.interface'

import type { ProjectKeysActionsSlice, ProjectKeysFetchPatch, ProjectKeysStore } from './project-keys.type'

type ProjectKeysSet = Parameters<StateCreator<ProjectKeysStore, [['zustand/immer', never]], [], ProjectKeysStore>>[0]

export const createProjectKeysSyncActions = (set: ProjectKeysSet): ProjectKeysActionsSlice => ({
  setState: (patch: ProjectKeysFetchPatch) => set((state) => ({ ...state, ...patch })),
  setGroups: (groups: ProjectResourceGroup[]) =>
    set((state) => {
      state.groups = groups
    }),
  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  setSelectedGroupId: (groupId) =>
    set((state) => {
      state.selectedGroupId = groupId
    }),
  setPendingSecrets: (secrets: GeneratedKeySecrets | null) =>
    set((state) => {
      state.pendingSecrets = secrets
    }),
  clearPendingSecrets: () =>
    set((state) => {
      state.pendingSecrets = null
    }),
})
